import classNames from 'classnames'
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image'
import React, { FC, ReactNode, useContext } from 'react'
import { useIntl } from 'react-intl'

import { LoadingContext } from 'ui/contexts/LoadingContext'

import styles from './styles.module.css'

interface Props {
  altTranslationId: string
  children?: ReactNode
  className?: string
  imageData: ImageDataLike | null
}

const FullscreenImage: FC<Props> = ({
  altTranslationId,
  children,
  className,
  imageData,
}) => {
  const { formatMessage } = useIntl()
  const [register, notify] = useContext(LoadingContext)
  const image = getImage(imageData)

  return (
    <div className={styles.fullscreen}>
      {image ? (
        <GatsbyImage
          alt={formatMessage({ id: altTranslationId })}
          className={classNames(styles.image, className)}
          image={image}
          loading="eager"
          objectFit="cover"
          onLoad={notify}
          onStartLoad={register}
        />
      ) : null}

      {children != null ? (
        <div className={styles.container}>{children}</div>
      ) : null}
    </div>
  )
}

export default FullscreenImage
